export const formatPlan = plan => {
    return {
        ...plan,
        price: plan.price / 100,
    }
};
